import { Badge } from '@/components/ui/badge';

interface AccountStatusBadgeProps {
  status: string | null;
}

export function AccountStatusBadge({ status }: AccountStatusBadgeProps) {
  if (!status) {
    return <Badge variant="pending">Unknown</Badge>;
  }

  const normalizedStatus = status.toLowerCase();

  if (normalizedStatus.includes('active') || normalizedStatus.includes('live')) {
    return <Badge variant="active">Active</Badge>;
  }

  if (normalizedStatus.includes('trial')) {
    return <Badge variant="trial">Trial</Badge>;
  }

  if (normalizedStatus.includes('cancel')) {
    return <Badge variant="cancelled">Cancelled</Badge>;
  }

  if (normalizedStatus.includes('pending') || normalizedStatus.includes('setup')) {
    return <Badge variant="pending">Pending</Badge>;
  }

  return <Badge variant="default">{status}</Badge>;
}
